import { Toaster } from "@/components/ui/sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Analytics from "@/components/Analytics";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import About from "./components/About";
import Products from "./components/Products";
import Contact from "./components/Contact";
import Blog from "./components/Blog";
import BlogPost from "./pages/BlogPost";
import Privacy from "./pages/Privacy";
import Faq from "./pages/Faq";

function AnimatedRoutes() {
  const location = useLocation();
  const reduce = useReducedMotion();

  return (
    <motion.div
      key={location.pathname}
      initial={reduce ? false : { opacity: 0, y: 10 }}
      animate={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
      transition={{ duration: reduce ? 0 : 0.25, ease: "easeOut" }}
      className="min-h-screen"
    >
      <Routes location={location}>
        <Route path="/" element={<Index />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </motion.div>
  );
}

const App = () => {
  const { t } = useTranslation();

  return (
    <>
      <Toaster />
      <BrowserRouter>
        <a
          href="#main"
          className="ed-eyebrow sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70] focus:rounded-full focus:border focus:border-foreground focus:bg-background focus:px-4 focus:py-2.5 focus:text-foreground"
        >
          {t("common.skipToContent")}
        </a>
        <Analytics />
        <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
          <AnimatedRoutes />
        </div>
      </BrowserRouter>
    </>
  );
};

export default App;
